import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const ServiceAreaMap = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const nearbyCities = [
    'Warsaw', 'Winona Lake', 'Pierceton', 'North Webster',
    'Syracuse', 'Milford', 'Leesburg', 'Mentone',
    'Claypool', 'Silver Lake', 'Akron', 'Rochester'
  ];

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="service-area" className="bg-brand-gray py-24 lg:py-32" ref={ref}>
      <div className="max-w-7xl mx-auto px-6 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left Content Panel */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.6 }}
            className="text-white"
          >
            <p className="text-brand-green text-sm font-bold uppercase tracking-widest mb-4">COVERAGE ZONE</p>
            <h2 className="text-5xl lg:text-6xl font-black mb-2">Serving Warsaw</h2>
            <p className="font-serif italic text-4xl lg:text-5xl text-gray-300 mb-8">& Surrounding Areas</p>
            
            <p className="text-xl text-gray-300 leading-relaxed mb-10">
              Professional concrete services within 30-mile radius of Warsaw, Indiana. We bring quality craftsmanship to your doorstep.
            </p>

            {/* Cities Grid */}
            <div className="grid grid-cols-2 gap-4 mb-10">
              {nearbyCities.map((city, index) => (
                <motion.div
                  key={city}
                  initial={{ opacity: 0, y: 10 }}
                  animate={inView ? { opacity: 1, y: 0 } : {}}
                  transition={{ duration: 0.4, delay: 0.3 + index * 0.05 }}
                  className="flex items-center gap-3"
                >
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-checkbox-circle-fill text-brand-green text-lg"></i>
                  </div>
                  <span className="text-gray-300 text-base">{city}</span>
                </motion.div>
              ))}
            </div>

            <button
              onClick={scrollToContact}
              className="bg-brand-green text-white px-10 py-4 rounded-full font-semibold hover:bg-brand-green/90 transition-all whitespace-nowrap cursor-pointer"
            >
              Request Service
            </button>
          </motion.div>

          {/* Right Map Panel */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="h-[500px] lg:h-[600px] rounded-2xl overflow-hidden shadow-2xl"
          >
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d195234.89474892!2d-85.9530!3d41.2381!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8816b8e4c7f0c5e5%3A0x7c3c3c3c3c3c3c3c!2s1905%20Crescent%20Dr%2C%20Warsaw%2C%20IN%2046580!5e0!3m2!1sen!2sus!4v1234567890"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Service Area Map - Warsaw, Indiana"
            ></iframe>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ServiceAreaMap;